<template>
  <transition name="fade">
    <div class="app-container"
         v-show="show">
      <transition name="top-slide">
        <div class="text-content"
             v-show="show">
          <div class="top-line"></div>
          <div class="text-content--title">
            <h4>{{ $t('top') }}</h4>
            <h4>{{ $t('bottom') }}</h4>
          </div>
          <div class="text-content--subtitle">
            <p>Connecting people , bringing happiness</p>
            <p>Create a multi-dimensional happy social space</p>
          </div>
          <div class="bottom-line"></div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<i18n>
{
  "ch": {
    "top": "联结你我 传送欢笑",
    "bottom": "创建多维度欢乐社交空间"
  },
  "zh": {
    "top": "聯結你我，傳送歡笑",
    "bottom": "創建多維度歡樂社交空間"
  },
  "en": {
    "top": " ",
    "bottom": " "
  }
}
</i18n>
<script>
export default {
  name: 'homeBanner',
  props: {
    show: [Boolean]
  }
}
</script>
<style lang="scss" scoped>
.top-slide-enter-active {
  //类名：隐藏到显示过程所需要的时间
  animation: top-slide 0.5s ease-out;
}
.top-slide-leave-active {
  //类名：显示到隐藏过程所需要的时间
  animation: top-slide 0.5s reverse ease-in; //reverse表示和隐藏到显示动画相反
}

@keyframes top-slide {
  0% {
    transform: translateY(-40%);
  }
  50% {
    transform: translateY(-15%);
  }
  100% {
    transform: translateY(0);
  }
}

.app-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .text-content {
    text-align: center;
    margin-top: 150px;
    &--title {
      h4 {
        font-size: 42px;
        color: #ffffff;
        letter-spacing: 0;
        margin: 30px 0;
      }
    }
    &--subtitle {
      p {
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: center;
        line-height: 36px;
        margin: 10px 0;
      }
    }
  }
}
.top-line {
  width: 72px;
  height: 8px;
  background: #ff512e;
  margin: auto;
}
.bottom-line {
  width: 40px;
  height: 8px;
  background: #ff512e;
  margin: auto;
  margin-top: 45px;
}
</style>
